import css from 'styled-jsx/css';
import { colors } from '../../../../themes';

export default css`
  .related-ads-modal {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 5;
  }

  .overlay {
    background-color: ${colors.black};
    height: 100%;
    left: 0;
    opacity: 0.4;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;
  }

  .modal {
    background-color: ${colors.white};
    border-radius: 8px;
    padding: 20px 3%;
    width: 90%;
    z-index: 2;
  }

  p {
    color: ${colors.black};
    font-size: 0.86em;
    margin: 0;
  }

  .subtitle {
    margin: 10px 0;
  }

  .related-title {
    color: #aeaeae;
    display: block;
    font-size: 0.86em;
    margin: 10px 0;
  }

  .list {
    margin: 10px 0;
  }
`;



// WEBPACK FOOTER //
// ./app/Serp/components/Modals/RelatedAdsModals/relatedAdsModalStyles.js